import ImportTable from './ImportTable';

export default ImportTable;
